//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { BodyText, TitleText } from '@components/atoms/text/Text';
import RightsImage from '@images/na_rights.svg';
import { SocialNetwork } from '@models/SocialNetwork';
import { isDefined } from '@utils/filterPredicates';

export interface UIANotSupportedRightsProps {
  socialNetwork: SocialNetwork;
  isRightsRequestsTwitterEnabled?: boolean;
  originalUrl?: string;
}

export const UIANotSupportedRights = ({
  socialNetwork,
  isRightsRequestsTwitterEnabled,
  originalUrl,
}: UIANotSupportedRightsProps) => (
  <Wrapper>
    <Image src={RightsImage} alt='Rights icon' />
    <TitleText>Not Supported</TitleText>
    {socialNetwork === SocialNetwork.Instagram && !isDefined(originalUrl) ? (
      <BodyText>
        We can't find the link to this <br />
        Instagram media.
      </BodyText>
    ) : (
      <BodyText>
        You can only request rights on an <br />
        Instagram {isRightsRequestsTwitterEnabled && (
          <span>or Twitter</span>
        )}{' '}
        image or video.
      </BodyText>
    )}
  </Wrapper>
);

const Wrapper = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacings[7]} ${theme.spacings[0]};
    width: 100%;
  `,
);

const Image = styled.img(
  ({ theme }) => `
    height: auto;
    width: calc(3 * ${theme.spacings[6]});
  `,
);
